import request from '@/utils/request'


// 传数组用data 使用params会自动拼接到URL后面去 导致请求报错
const batchReconciliation = (consignment_order_id_arr) => {
    return request({
        url: "/api/backend/consignment/batchReconciliation",
        method: "post",
        data: {
            consignment_order_id_arr: consignment_order_id_arr
        },
    })
}

export default {
    batchReconciliation,

}